import React from 'react';
import { useNavigate } from 'react-router-dom';

const AccountSuspended = () => {
  const navigate = useNavigate();

  const handleContactSupport = () => {
    window.location.href =
      'mailto:support@lastzoneindia.com?subject=Account Suspension Inquiry';
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0a0a0f] px-4">
      <div className="max-w-md w-full bg-[#1a1a2e]/50 backdrop-blur-xl rounded-2xl p-8 border border-red-500/20">
        <div className="text-center">
          <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-10 h-10 text-red-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          <h1 className="text-2xl font-rajdhani font-bold text-white mb-2">
            Account Suspended
          </h1>

          <p className="text-gray-400 text-sm mb-6">
            Your account has been suspended due to a violation
            of our terms of service. Please contact our support
            team for more information.
          </p>

          <div className="space-y-3">
            <button
              onClick={handleContactSupport}
              className="w-full py-3 bg-gradient-to-r from-purple-500 to-blue-500 text-white font-rajdhani font-bold rounded-xl hover:scale-[1.02] transition-transform"
            >
              Contact Support
            </button>

            <button
              onClick={() =>
                navigate('/', { replace: true })
              }
              className="w-full py-3 bg-white/5 text-gray-400 font-rajdhani font-bold rounded-xl hover:bg-white/10 transition-colors"
            >
              Go Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AccountSuspended;